import { observer } from "mobx-react";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { IRoom } from "../../models/room/Room";
import { DropdownButton } from "../dropdownButton";
import styles from "./currentClientContainer/currentClientContainer.css";
import { logger } from "@fidget/common/utils";

interface Props {
  room: IRoom;
}

export const StateButton = observer((props: Props) => {
  logger.info(`Room state button rendered: ${props.room.id} isClosed=${props.room.isClosed}`);
  return props.room.isClosed ? (
    <DropdownButton
      label={intl.formatMessage("conversation.reopen.title")}
      options={[]}
      onAction={() => props.room.reopen()}
      className={styles["close-conversation-button"]}
    />
  ) : (
    <DropdownButton
      label={intl.formatMessage("conversation.close.title")}
      options={[
        { label: intl.formatMessage("conversation.close.option.solved"), value: "solved" },
        { label: intl.formatMessage("conversation.close.option.unsolved"), value: "unsolved" }
      ]}
      onAction={(v) => props.room.close(v === "solved")}
      className={styles["close-conversation-button"]}
    />
  );
});
